import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBlock,
  Button
} from "reactstrap";

import ReactTable from 'react-table';
import 'react-table/react-table.css';


import { Link } from 'react-router-dom';

import Widget04 from '../Widgets/Widget04';

import * as Constant from '../../constants/AppConstants';
import axios from 'axios';

import { loadProgressBar } from 'axios-progress-bar';

$('body').on('click', '.selectAllLeads', function (event) {
  if ($(this).prop('checked')) {
    $('body').find('.selectLeads').prop('checked', true);
  }
  else {
    $('body').find('.selectLeads').prop('checked', false);
  }
});
loadProgressBar()

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      leadsData: [],
      drop: {},
      dashboardData: [],
      loading: true,
      average_disbursed_amount: '',
      total_disbursed_amount: '',
      limit: 25,
      offset: 0,
      query: '',
      lead_status: '',
      loan_status: '',
      applicationStatus: '',
      sort_col: '',
      sort: '',
      loggedOutModal: false,
      options: [],
      org_role: '',
      payback: 0,
    };
    this.getDashboard = this.getDashboard.bind(this);
    this.nextpage = this.nextpage.bind(this);
    this.previouspage = this.previouspage.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.addFilter = this.addFilter.bind(this);
    this.navigateToLogin = this.navigateToLogin.bind(this);
    this.logout = this.logout.bind(this);
    this.toggleLoggedOutModal = this.toggleLoggedOutModal.bind(this);
    this.verifyAuthToken = this.verifyAuthToken.bind(this);

  }
  componentDidMount() {
    this.getLeads();
    // this.getDashboard();
  }

  verifyAuthToken() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.VERIFY_TOKEN_MODE,
      auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
      token: window.localStorage.getItem(Constant.TOKEN)
    })
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        // console.log(response);
        if (response.status == 200) {
          self.getUserDetails();
        } else {
          self.logout();
        }
      })
      .catch(function (error) {
        self.logout();
      });
  }

  nextpage() {
    this.setState({
      offset: this.state.offset + this.state.limit
    }, this.getLeads);

  }

  previouspage() {

    var offset = this.state.offset - this.state.limit;
    if (offset < 0) {
      offset = 0;
    }
    this.setState({
      offset: offset
    }, this.getLeads);

  }

  addFilter(e) {
    e.preventDefault();
    this.setState({
      offset: 0
    }, this.getLeads);

  }

  getLeads() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.GET_LEAD_MODE,
      "filters[query]": this.state.query,
      "filters[loan_status]": this.state.loan_status,
      "filters[lead_status]": this.state.lead_status,
      "filters[applicationStatus]": this.state.applicationStatus,
      "filters[start_date]": this.state.start_date,
      "filters[end_date]": this.state.end_date,
      sort: this.state.sort,
      sort_col: this.state.sort_col,

      limit: this.state.limit,
      offset: this.state.offset,
    }
    )
    // console.log("Auth token: " + window.localStorage.getItem(Constant.AUTH_TOKEN));

    this.setState({
      loading: true
    });

    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          self.setState(prevState => ({
            leadsData: response.data.leads,
            // payback:response.data.payback,
            loading: false
          }));
        } else {
          // console.log(response);
          self.setState(prevState => ({
            loading: false
          }));
        }
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
        self.setState(prevState => ({
          loading: false
        }));
      });
  }


  getDashboard() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.GET_DASHBOARD_DATA,


    })
    // console.log("Auth token for dashboard: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          // console.log(response);
          var total_disbursed_amount = (response.data.reports.total_disbursed_amount);
          var average_disbursed_amount = Math.round(response.data.reports.average_disbursed_amount);
          var options = (response.data.agents);
          var org_role = (response.data.user_details.org_role);
          self.setState(prevState => ({
            dashboardData: response.data.reports,
            options: options,
            org_role: org_role,
            total_disbursed_amount: total_disbursed_amount,
            average_disbursed_amount: average_disbursed_amount,
            loading: false
          }));
        }
        else if (response.data.error === "Invalid auth token") {
          // console.log(response);
          self.toggleLoggedOutModal();
        }
        else if (response.data.error === "Login Expired") {
          // console.log(response);
          self.toggleLoggedOutModal();
        }
        else {
          // console.log(response);
        }
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
        self.setState(prevState => ({
          loading: false
        }));
      });
  }

  toggleLoggedOutModal() {
    this.setState({
      loggedOutModal: !this.state.loggedOutModal,
      mail_sent: false,
      mail_unable_to_send: false,
    })
  }

  navigateToLogin() {
    this.props.history.push('/login');
  }


  refreshPage() {
    window.location.reload()
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, function () {

    });

  }

  logout() {
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
      mode: Constant.MODE_LOGOUT
    })
    // console.log("Auth token: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
    axios({
      method: 'post',
      // url: 'https://devapi.stasheasy.com/Admin/services/',
      url: 'https://api.stashfin.com/Admin/services',
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
        'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
      .then(function (response) {
        if (response.status == 200) {
          // console.log(response);
          window.localStorage.setItem(Constant.AUTH_TOKEN, "");
          window.localStorage.setItem(Constant.TOKEN, "");
          window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
          window.localStorage.setItem(Constant.ORG_ID, "");
          self.navigateToLogin();
        } else {
          // console.log(response);
          window.localStorage.setItem(Constant.AUTH_TOKEN, "");
          window.localStorage.setItem(Constant.TOKEN, "");
          window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
          window.localStorage.setItem(Constant.ORG_ID, "");
          self.navigateToLogin();
        }
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
        window.localStorage.setItem(Constant.AUTH_TOKEN, "");
        window.localStorage.setItem(Constant.TOKEN, "");
        window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
        window.localStorage.setItem(Constant.ORG_ID, "");
        self.navigateToLogin();
      });

  }

  assign_leads_to_agent() {
    var sendarray = [];
    var selected = '';
    var json_sendarray = [];

    selected = $('#agent_dropdown').children('option:selected').val();
    $('.selectLeads').each(function (event) {

      //var checkbox = $(this).find('.selectLeads').attr('data-id');
      if ($(this).prop("checked")) {
        sendarray.push($(this).attr('data-id'));
      }
    });

    var querystring = require('querystring');
    json_sendarray = JSON.stringify(sendarray);
    // console.log(sendarray.length);
    // console.log(json_sendarray.val)
    // console.log(selected);
    if (sendarray == undefined || sendarray.length === 0) {
      alert("No leads assigned");
    }
    else if (selected == '' || selected == null || selected == 0) {
      alert("No agents assigned");

    }
    else {
      var payload = new FormData();
      payload.append("mode", Constant.ASSIGN_LEADS);
      payload.append("leads", json_sendarray);
      payload.append("agent_id", selected);
      // console.log(payload);
      axios({
        method: 'post',
        url: Constant.API_URL,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
          'token': window.localStorage.getItem(Constant.TOKEN)
        },
        withCredentials: false,
        data: payload
      })
        .then(function (response) {
          if (response.status == 200) {
            //console.log(response);
            alert('Lead(s) Assigned Successfully');

            window.location.reload();
          } else {
            //console.log(response);
            self.setState(prevState => ({
              serverError: response.data.error
            }));
          }
        })
        .catch(function (error) {
          // console.log("Error");
          // console.log(error);
        });
    }
  }

  render() {

    return (
      <div>
        <Row>
          <Col md="2.1" className="report-bx">
            <Widget04 icon="icon-people" color="info" header={this.state.dashboardData.total_leads} invert>Total Loan Applications</Widget04>
          </Col>
          <Col md="2.1" className="report-bx">
            <Widget04 icon="icon-user-follow" color="primary" header={this.state.dashboardData.new_leads} invert>New Loan Applications</Widget04>
          </Col>
          <Col md="2.1" className="report-bx">
            <Widget04 icon="icon-check" color="success" header={this.state.dashboardData.approved_leads} invert>Approved applications</Widget04>
          </Col>
          <Col md="2.1" className="report-bx">
            <Widget04 icon="icon-ban" color="danger" header={this.state.dashboardData.rejected_leads} invert>Rejected applications</Widget04>
          </Col>
          <Col md="2.1" className="report-bx">
            <Widget04 icon="icon-clock" color="warning" header={this.state.dashboardData.pending_applications} invert>Pending Leads</Widget04>
          </Col>
        </Row>
        <Card>
          <CardHeader>
            {(this.state.org_role == '1') ? (
              <span>
                <select id="agent_dropdown" className="selectpick" style={{ padding: '5px', marginRight: '15px', color: 'black' }}>
                  <option value="0" selected="selected">Assign Agent</option>
                  {this.state.options.map((options) => <option value={options.id}>{options.name}</option>)
                  }
                </select>
                <button type="button" onClick={this.assign_leads_to_agent} id="assignagent" className="btn btn-secondary assign-agent-button">Assign</button>
              </span>) : ('')}
            {/* <CSVLink data={this.state.emis}
                filename={"emi-schedule"+""+currentdate.getDate()+""+currentdate.getMonth()+1+""+currentdate.getFullYear()+""+currentdate.getHours()+""
                +currentdate.getMinutes()+currentdate.getSeconds()+".csv"}
                className="btn btn-primary"
                >Download EMI Details
            </CSVLink> */}
            <Button className="float-right" color="link" onClick={this.refreshPage}><i className="fa fa-refresh"><strong> Refresh</strong></i></Button>
          </CardHeader>

          <CardBlock className="card-body">
            <form>
              <input ref="srch" type="search" className="deepsearchinput" size="35" name="query" value={this.state.query || ''} placeholder="Lead_id, Reference_no, Lead_name, Email" title="Lead_id, Reference_no, Lead_name, Email" onChange={(event) => this.handleUserInput(event)} />&nbsp;&nbsp;


              <select name="lead_status" id="select" className="deepsearchselect" value={this.state.lead_status || ''} onChange={(event) => this.handleUserInput(event)}>

                <option value="">Lead Status</option>
                <option value="1">New</option>
                <option value="2">Phone not Picked</option>
                <option value="3">Call Back</option>
                <option value="4">Not Interested</option>
                <option value="5">Sent for CIBIL</option>
                <option value="6">CIBIL Approved</option>
                <option value="7">CIBIL Rejected</option>
                <option value="8">Perfios Pending</option>
                <option value="9">Analyze Perfios</option>
                <option value="10">Loan Approved</option>
                <option value="11">Loan Rejected</option>
                <option value="12">Document Collection</option>
                <option value="13">Disbursed</option>
                <option value="14">Exception</option>
                <option value="15">Not Eligible</option>
                <option value="16">CIBIL Done</option>
                <option value="17">Follow Up</option>
                <option value="18">Not Contactable</option>
                <option value="19">Ok for CIBIL</option>
                <option value="20">Test Lead</option>
                <option value="21">Duplicate</option>
                <option value="22">Refer For CIBIL</option>
                <option value="23">Credit Query</option>
                <option value="24">Perfios Query</option>
                <option value="25">Unwilling to Do Perfios</option>
                <option value="26">Refer for Perfios</option>
                <option value="28">Reference Verification Pending</option>
                <option value="29">References Verification Done</option>
                <option value="30">Rejected - Case to Avoid</option>
                <option value="31">Credit Query Response</option>
                <option value="32">Perfios Query Response</option>
                <option value="33">Do Not Call</option>
                <option value="34">References Not Available</option>
                <option value="35">References Available</option>
                <option value="36">First Contact Made</option>
                <option value="37">cibil error</option>
                <option value="38">Perfios - Call Back</option>
                <option value="39">Perfios - Not Contactable</option>
                <option value="40">Perfios - Bank not Listed</option>
                <option value="41">Perfios - Upload Bank Statement</option>
                <option value="42">Document Checklist Done</option>
                <option value="43">Document Pick-up Done</option>
                <option value="44">Document Issues Found</option>
                <option value="45">Document Verified</option>
                <option value="47">Document Issue Resolved</option>
                <option value="64">Sent For Doc pickup</option>
                <option value="76">Pendency</option>

              </select>&nbsp;&nbsp;

              <select name="applicationStatus" id="select" className="deepsearchselect" value={this.state.applicationStatus || ''} onChange={(event) => this.handleUserInput(event)}>

                <option value="">Application status</option>
                <option value="complete">Complete</option>
                <option value="rejected">Rejected</option>
                <option value="processing">Processing</option>
                <option value="incomplete">Incomplete</option>
                <option value="pending_otp">Pending OTP</option>

              </select>&nbsp;&nbsp;

              <input type="date" className="deepsearchinput" name="start_date" value={this.state.start_date || ''} onChange={(event) => this.handleUserInput(event)} />&nbsp;&nbsp;
              <input type="date" className="deepsearchinput" name="end_date" value={this.state.end_date || ''} onChange={(event) => this.handleUserInput(event)} />&nbsp;&nbsp;

              <Button type="submit" className="deepearchsubmit" onClick={this.addFilter}>Search:</Button>

              {/* {
                  window.localStorage.getItem(Constant.INV_ACC) == 1?
                  <div className="generate-invoice">
                
                  <Link to={"/generateInvoice"}>
                    <button className="generate-invoice__button">
                      Generate Invoice
                    </button>
                  </Link>
                  <Link to={"/dsaDetails"}>
                    <button className="generate-invoice__button">
                      DSA Details
                    </button>
                  </Link>

                  </div>
                :
                  ""
                } */}
            </form>

            {this.state.payback ?
              <ReactTable data={this.state.leadsData} columns={[
                {
                  Header: ({ original }) => {
                    return
                    (<input type="checkbox" className="selectAllLeads" />);
                  }, sortable: false, accessor: 'lead_id',
                  Cell: row => (<input type="checkbox" data-id={row.value} className="selectLeads" />),
                  className: "cell-text-align",
                },
                {
                  Header: 'Lead ID', id: 'lead_id', accessor: d => d.lead_id, Cell: row => (
                    <span>{row.value}</span>),
                },
                {
                  Header: 'Application Status', accessor: 'application_status',
                  Cell: row => (
                    <div>
                      <span className="approvalstatus" style={{
                        backgroundColor: row.value === 'complete' ? '#4caf50' : row.value === 'rejected' ? '#e20808' : row.value === 'processing' ? '#ffff00' : row.value === 'incomplete' ? '#00e5ff' : row.value === 'pending_otp' ? '#e3edef' :
                          '', transition: 'all .3s ease'
                      }}></span>
                      <span> {
                        row.value === 'complete' ? 'complete'
                          : row.value === 'rejected' ? 'rejected'
                            : row.value === 'processing' ? 'processing'
                              : row.value === 'pending_otp' ? 'pending OTP'
                                : row.value === 'incomplete' ? 'incomplete'
                                  : ''
                      }
                      </span>
                    </div>
                  )
                },
                { Header: 'Agent Name', accessor: 'assign_agent' },
                { Header: 'Lead name', accessor: 'customer_name' },
                { Header: 'Email', accessor: 'email' },
                { Header: 'Phone No.', accessor: 'phone' },
                {
                  Header: 'Office Email Status', accessor: 'office_email_status',
                  Cell: row => (row.value == 1 ? "Yes" : "No")
                },
                { Header: 'Lead Status', accessor: 'lead_status' },
                { Header: 'Loan Status', accessor: 'loan_status', Cell: row => (row.value === null ? "Not Available" : row.value) },
                {
                  Header: 'Source', accessor: 'agent_name',
                  Cell: row => (row.value === null ? "LMS" : "Lite-LMS")
                }
              ]} defaultPageSize={this.state.limit} showPaginationBottom={false} defaultSorted={[{ id: 'lead_id', desc: true }]} className="-striped -highlight" onFetchData={this.getDashboard} loading={this.state.loading}
              />
              :
              <ReactTable data={this.state.leadsData} columns={[
                {
                  Header: ({ original }) => {
                    return (<div className="header-align-left">Select</div>);
                  }, sortable: false, accessor: 'lead_id',
                  Cell: row => (<input type="checkbox" data-id={row.value} className="selectLeads" />),
                },
                {
                  Header: () => (
                    <div className="header-align-left">Application ID</div>), id: 'lead_id', accessor: d => (d.lead_id, d.ref_no),
                  // Cell: row => (<span><Link to={"/loanDetails/" + row.original.lead_id}>{row.original.lead_id}</Link></span>),
                  Cell: row => (<span><Link to={"/loanDetails/" + row.original.ref_no}>{row.original.lead_id}</Link></span>),

                },
                { Header: 'Random Loan Id', accessor: 'ref_no' },
                {
                  Header: 'Application Status', accessor: 'application_status',
                  Cell: row => (
                    <div>
                      <span className="approvalstatus" style={{
                        backgroundColor: row.value === 'complete' ? '#4caf50' : row.value === 'rejected' ? '#e20808' : row.value === 'processing' ? '#ffff00' : row.value === 'incomplete' ? '#00e5ff' : row.value === 'pending_otp' ? '#e3edef' :
                          '', transition: 'all .3s ease'
                      }}></span>
                      <span> {
                        row.value === 'complete' ? 'complete'
                          : row.value === 'rejected' ? 'rejected'
                            : row.value === 'processing' ? 'processing'
                              : row.value === 'pending_otp' ? 'pending OTP'
                                : row.value === 'incomplete' ? 'incomplete'
                                  : ''
                      }</span>
                    </div>
                  )
                },
                { Header: 'Agent Name', accessor: 'assign_agent' },
                { Header: 'Lead name', accessor: 'customer_name' },
                { Header: 'Email', accessor: 'email' },
                { Header: 'Phone No.', accessor: 'phone' },
                {
                  Header: 'Office Email Status', accessor: 'office_email_status',
                  Cell: row => (<span>{row.original.office_email === null || row.original.office_email === undefined ? "No" : "Yes"}</span>)
                },
                { Header: 'Lead Status', accessor: 'lead_status' },
                { Header: 'Loan Status', accessor: 'loan_status', Cell: row => (<span>{row.value === null ? "Not Available" : row.value}</span>)},
                {
                  Header: 'Source', accessor: 'agent_name',
                  Cell: row => (<span>{row.value === null ? "LMS" : "Lite-LMS"}</span>)
                }
              ]} defaultPageSize={this.state.limit} showPaginationBottom={false} defaultSorted={[{ id: 'lead_id', desc: true }]} className="-striped -highlight" onFetchData={this.getDashboard} loading={this.state.loading}
              />
            }

            {this.state.loading === true ?
              <div>
                <Button className="float-right"><strong className=""> Loading...</strong></Button>
              </div>
              :
              <div>
                <Button className="float-right" color="link" onClick={this.nextpage}><strong> Next</strong></Button>
                <Button className="float-left" color="link" onClick={this.previouspage}><strong> Previous</strong></Button>

              </div>

            }

            {this.state.loggedOutModal ?
              this.navigateToLoanDetails() : ''
            }

            {/* <Modal isOpen={this.state.loggedOutModal} toggle={this.logout} className={this.props.className}>
                    <ModalHeader toggle={this.logout}>Session expired</ModalHeader>
                    <ModalBody>
                        Session expired, login again
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.logout}>Login</Button>
                    </ModalFooter>
                </Modal> */}
          </CardBlock>
        </Card>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js